import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Shared from "@/components/features/items/discount/_shared";

export const useDiscountListForDiscountQuery = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(Shared.Model.Repository.Query.DISCOUNT_LIST_FOR_DISCOUNT_QUERY, {
		variables: { hotelID },
		fetchPolicy: "network-only",
	});

	return {
		data,
	};
};
